import { Button, Form, Input, Radio, Select, Typography, message } from "antd";
import React, { useState, useEffect } from "react";
import { Modal, Tooltip } from 'antd';
import "./CreateEmail.scss";

import {
  MailOutlined,
  UserOutlined,
  SwapOutlined,
  KeyOutlined,
  GoogleOutlined,
  NodeIndexOutlined,
  QuestionCircleOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import { useTheme } from "@emotion/react";
import { apiGet, apiPost } from "app/services/apiServices";
import {
  API_ENDPOINT_EMAIL_CREATE,
  API_ENDPOINT_EMAIL_GET_WORKSPACE_LIST,
  API_ENDPOINT_EMAIL_ADD_NEW
} from "app/scenes/Credentials/credentials.constants";
import TextField from "app/shared/TextField";
import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
// @ts-ignore
import Tour from 'reactour'
import zoho from '../zoho.png'
import outlook from '../Outlook.png'

const ImapConfig: any = {
  Gmail: {
    host: "imap.gmail.com",
    port: 993,
  },
  Outlook: {
    host: "outlook.office365.com",
    port: 993,
  },
  //dummy--
  zoho: {
    host: "imappro.zoho.in",
    port: 993,
  },
  Custom: {
    host: "outlook.office365.com",
    port: 993,
  },
};
function CreateEmail(props: any) {
  const { isEditMode = false, editData = null } = props;
  const [imapHost, setImapHost] = useState("");
  const [imapPort, setImapPort] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [workspace, setWorkspace] = useState(
    "d1befcd7-877b-4544-838f-0e995cab5466"
  );
  const [gmailPassword, setGmailPassword] = useState("");
  const [serviceProvider, setServiceProvider] = useState("");
  const [secondaryProvider, setSecondaryProvider] = useState<string | null>(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setLoading] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const [clientId, setClientId] = useState("");
  const [tenantId, setTenantId] = useState("")

  const [verificationUri, setVerificationUri] = useState("");
  const [session_id, setSession_id] = useState("")
  const [code, setCode] = useState("")
  const [tooltipText, setTooltipText] = useState('Copy code');

  const [form] = Form.useForm();

  const resetModalState = () => {
    setVerificationUri("");
    setSession_id("");
    setCode("");
    setLoginEmail("");
    setLoginPassword("");
    setGmailPassword("");
    setServiceProvider("Gmail");
    setSecondaryProvider("");
    setImapHost("");
    setImapPort("");
    setClientId("");
    setTenantId("");
  };

  // Replace the static Steps array with a dynamic getSteps function
  const getSteps = () => {
    if (serviceProvider === "Gmail" || serviceProvider === "zoho") {
      return [
        {
          selector: '#Password',
          content: 'Use your email account password. If you are using Gmail with 2-Step Verification enabled, you must use an app-specific password instead.',
          position: 'top',
        },
        {
          selector: '#appPassword',
          content: () => (
            <div>
              <p>
                An app password is required if your account has 2-Step Verification enabled. 
                Generate it from your Google Account under <b>Security &gt; App Passwords</b>.
              </p>
              <a
                href="https://docs.google.com/document/d/1Fg08TKvWJY-24eBfqe4Rr8T2NIsWsOdnzjVB4fsrQsI/edit?addon_store&tab=t.0"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0a8394', fontWeight: 500 }}
              >
                Show more
              </a>
            </div>
          ),
          position: 'top',
        },
      ];
    } else if (serviceProvider === "Custom") {
      return [
        {
          selector: '#IMAP',
          content: 'The IMAP Host is the address of your email provider\'s incoming mail server. This is required to retrieve your emails. Where to find it: Most email providers list this in their support or account settings page. For example: Gmail: imap.gmail.com Yahoo: imap.mail.yahoo.com Outlook: imap-mail.outlook.com',
          position: 'top',
        },
        {
          selector: '#imapPort',
          content: "The IMAP Port is the server port number used to establish a connection with the IMAP server. Where to find it: Check your email provider's documentation. Typically, secure IMAP uses port 993.",
          position: 'top',
        },
        {
          selector: '#Password',
          content: 'Use your email account password.',
          position: 'top',
        },
      ];
    } else if (serviceProvider === "Outlook") {
      if (secondaryProvider === "Delegated") {
        return [
          {
            selector: '#auth-method-info',
            content: 'Select how the app will authenticate with Outlook.',
            position: 'top',
          },
          {
            selector: '#Password',
            content: 'Use your Outlook account password.',
            position: 'top',
          },
          {
            selector: '#auth-method-delegated-clientID',
            content: 'Application (Client) ID from Azure App Registration. You can find this in the Azure Portal under Azure Active Directory > App registrations > Your App > Overview.',
            position: 'top',
          },
          {
            selector: '#auth-method-delegated-tenantID',
            content: 'Directory (Tenant) ID from Azure Active Directory. This uniquely identifies your organization\'s Microsoft 365 directory. Found in the same Overview page of the registered app in Azure Portal.',
            position: 'top',
          },
        ];
      } else if (secondaryProvider === "App") {
        return [
          {
            selector: '#auth-method-info',
            content: 'Select how the app will authenticate with Outlook.',
            position: 'top',
          },
          {
            selector: '#Password',
            content: 'Use your Outlook account password.',
            position: 'top',
          },
          {
            selector: '#auth-method-delegated-clientID',
            content: 'Application (Client) ID from Azure App Registration. You can find this in the Azure Portal under Azure Active Directory > App registrations > Your App > Overview.',
            position: 'top',
          },
          {
            selector: '#auth-method-delegated-tenantID',
            content: 'Directory (Tenant) ID from Azure Active Directory. This uniquely identifies your organization\'s Microsoft 365 directory. Found in the same Overview page of the registered app in Azure Portal.',
            position: 'top',
          },
          {
            selector: '#appPassword',
            content: 'App password for Outlook App-based authentication.',
            position: 'top',
          },
        ];
      } else if (secondaryProvider === "AppBased") {
        return [
          {
            selector: '#auth-method-info',
            content: 'Select how the app will authenticate with Outlook.',
            position: 'top',
          },
          {
            selector: '#Password',
            content: 'Use your Outlook account password.',
            position: 'top',
          },
        ];
      }
    }
    return [];
  };
  const getStepIndexBySelector = (selector: string) => {
    const steps = getSteps();
    return steps.findIndex(step => step.selector === selector);
  };
  useEffect(() => {
    if (isEditMode && editData) {
      
      // Determine service provider based on imap_host
      let provider = "Custom";
      if (editData.imap_host === "imap.gmail.com") {
        provider = "Gmail";
      } else if (editData.imap_host === "outlook.office365.com") {
        provider = "Outlook";
      } else if (editData.imap_host === "imappro.zoho.in") {
        provider = "zoho";
      }
      
      setServiceProvider(provider);
      setLoginEmail(editData.email || "");
      
      // Use the direct values from the response
      setLoginPassword(editData.email_password || "");
      setGmailPassword(editData.gmail_app_password || "");
      
      // Set workspace if available
      if (editData.workspace_id) {
        setWorkspace(editData.workspace_id);
      }
      
      // Set IMAP config - use the actual values from the response
      setImapHost(editData.imap_host || "");
      setImapPort(editData.imap_port?.toString() || "");
      
      // For Outlook, you might need to extract client_id and tenant_id from outlook_config
      if (provider === "Outlook" && editData.outlook_config) {
        console.log("Outlook config available:", editData.outlook_config);
         }
      
      console.log("Form state after setting:", {
        serviceProvider: provider,
        loginEmail: editData.email,
        loginPassword: editData.email_password,
        gmailPassword: editData.gmail_app_password,
        imapHost: editData.imap_host,
        imapPort: editData.imap_port
      });
    }
  }, [isEditMode, editData, form]);

  // Add this useEffect to monitor state changes
  useEffect(() => {
    console.log("State updated:", {
      serviceProvider,
      loginEmail,
      loginPassword,
      gmailPassword,
      imapHost,
      imapPort,
      clientId,
      tenantId,
      secondaryProvider
    });
  }, [serviceProvider, loginEmail, loginPassword, gmailPassword, imapHost, imapPort, clientId, tenantId, secondaryProvider]);

  // Add this useEffect after your existing useEffect
  useEffect(() => {
    if (isEditMode && editData) {
      // Update form fields with current state values
      form.setFieldsValue({
        login_email: loginEmail,
        app_password: loginPassword,
        client_secret: gmailPassword,
        client_id: clientId,
        tenant_id: tenantId,
        imap_host: imapHost,
        imap_port: imapPort
      });
    }
  }, [loginEmail, loginPassword, gmailPassword, clientId, tenantId, imapHost, imapPort, isEditMode, editData, form]);

  const handleVerificationClick = async (e: React.MouseEvent) => {
    setLoading(true);

    try {
      const verifierPollResponse = await apiPost(
        "https://verifier.finkraftai.com/delegate-waiting-poll",
        { session_id: session_id }
      );

      if (verifierPollResponse.status === "success") {
        const selectedImapConfig = ImapConfig[serviceProvider] || { host: "", port: "" };
        const currentWorkspace = localStorage.getItem("currentWorkspace");

        // Prepare the payload for your local /addNew API
        const addNewPayload = {
          workspace_id: currentWorkspace,
          email: loginEmail,
          email_password: loginPassword,
          imap_host: selectedImapConfig.host,
          imap_port: parseInt(selectedImapConfig.port),
          gmail_app_password: gmailPassword,
          ...(isEditMode && editData?.email_login_id && { email_login_id: editData.email_login_id }),
          status: "SUCCESS", // Set SUCCESS status for both create and edit modes
        };

        const addResponse = await apiPost(API_ENDPOINT_EMAIL_ADD_NEW, addNewPayload);

        if (addResponse.status) {
          messageApi.open({
            type: "success",
            content: addResponse.message,
          });
          props.onSuccess && props.onSuccess();
          resetModalState();
        } else {
          messageApi.error({
            type: "error",
            content: addResponse.message,
          });
          resetModalState();
        }
      } else {
        // Validation failed
        if (isEditMode) {
          // For edit mode, update with FAILED_LOGIN status
          const selectedImapConfig = ImapConfig[serviceProvider] || { host: "", port: "" };
          const currentWorkspace = localStorage.getItem("currentWorkspace");
          
          const addNewPayload = {
            workspace_id: currentWorkspace,
            email: loginEmail,
            email_password: loginPassword,
            imap_host: selectedImapConfig.host,
            imap_port: parseInt(selectedImapConfig.port),
            gmail_app_password: gmailPassword,
            email_login_id: editData.email_login_id,
            status: "FAILED_LOGIN",
          };
          
          const addResponse = await apiPost(API_ENDPOINT_EMAIL_ADD_NEW, addNewPayload);
          
          if (addResponse.status) {
            messageApi.open({
              type: "warning",
              content: "Credential updated but validation failed. Please check your credentials.",
            });
            props.onSuccess && props.onSuccess();
            resetModalState();
          } else {
            messageApi.error({
              type: "error",
              content: addResponse.message,
            });
            resetModalState();
          }
        } else {
          // For create mode, don't insert if validation fails
          messageApi.open({
            type: "error",
            content: "Validation not successful. Couldn't add the credential.",
          });
          props.onClose && props.onClose();
          resetModalState();
        }
      }
    } catch (error: any) {
      // Handle error case
      if (isEditMode) {
        // For edit mode, update with FAILED_LOGIN status even on error
        const selectedImapConfig = ImapConfig[serviceProvider] || { host: "", port: "" };
        const currentWorkspace = localStorage.getItem("currentWorkspace");
        
        const addNewPayload = {
          workspace_id: currentWorkspace,
          email: loginEmail,
          email_password: loginPassword,
          imap_host: selectedImapConfig.host,
          imap_port: parseInt(selectedImapConfig.port),
          gmail_app_password: gmailPassword,
          email_login_id: editData.email_login_id,
          status: "FAILED_LOGIN",
        };
        
        try {
          const addResponse = await apiPost(API_ENDPOINT_EMAIL_ADD_NEW, addNewPayload);
          
          if (addResponse.status) {
            messageApi.open({
              type: "warning",
              content: "Credential updated but validation failed due to an error.",
            });
            props.onSuccess && props.onSuccess();
            resetModalState();
          }
        } catch (updateError) {
          messageApi.error({
            type: "error",
            content: "Failed to update credential.",
          });
          resetModalState();
        }
      } else {
        messageApi.error({
          type: "error",
          content: error?.message || "Something went wrong during verification.",
        });
        props.onClose && props.onClose();
        resetModalState();
      }
    } finally {
      setLoading(false);
    }
  };


  const handleCreateEmail = async () => {
    const currentWorkspace = localStorage.getItem("currentWorkspace");
    setLoading(true);

    const selectedImapConfig = ImapConfig[serviceProvider] || { host: "", port: "" };

    // Prepare the payload for your local /addNew API
    const addNewPayload = {
      workspace_id: currentWorkspace,
      email: loginEmail,
      email_password: loginPassword,
      imap_host: selectedImapConfig.host,
      imap_port: parseInt(selectedImapConfig.port),
      gmail_app_password: gmailPassword,
      ...(isEditMode && editData?.email_login_id && { email_login_id: editData.email_login_id }),
      // Add status logic - will be updated based on validation result
      status: "PENDING", // Initial status, will be updated after validation
    };

    // Prepare the payload for verifier API
    const verifierPayload = {
      mailType: serviceProvider.toLowerCase(), // e.g., "gmail"
      config: {
        email: loginEmail,
        email_password: loginPassword,
        imap_host: selectedImapConfig.host,
        imap_port: parseInt(selectedImapConfig.port),
        gmail_app_password: gmailPassword || null,
        is_app_password_login: serviceProvider === "Outlook" ? "True" : "False",
        // ...(serviceProvider === "Outlook" && secondaryProvider && {
        //   type: secondaryProvider.toLowerCase(),
        // }),
      //   client_id: clientId,
      //   tenant_id: tenantId
      // },
          ...(serviceProvider === "Outlook" &&
      secondaryProvider &&
      ["delegated", "app"].includes(secondaryProvider.toLowerCase()) && {
        client_id: clientId,
        tenant_id: tenantId,
      })
      }
    }

    try {
      // Step 1: Choose verifier API based on serviceProvider
      let verifierInitResponse: any;

      if (serviceProvider === "Outlook") {
        verifierInitResponse = await apiPost("https://verifier.finkraftai.com/run-outlook-logins", verifierPayload);

        if (verifierInitResponse?.status === "success") {
          setVerificationUri(verifierInitResponse.verification_uri);
          setSession_id(verifierInitResponse.session_id);
          setCode(verifierInitResponse.user_code)
        } else {
          messageApi.error({
            type: "error",
            content: "Failed to initiate verification. Please try again.",
          });
          setLoading(false);
          return;
        }
      } else if (serviceProvider === "Gmail" || serviceProvider === "zoho" || serviceProvider === "Custom") {
        verifierInitResponse = await apiPost("https://verifier.finkraftai.com/run-email-logins", verifierPayload);
      } else {
        messageApi.error({
          type: "error",
          content: "Unsupported service provider selected.",
        });
        setLoading(false);
        return;
      }


      // Check if verifier API response is valid
      if (!verifierInitResponse) {
        messageApi.error({
          type: "error",
          content: "Verification service is not responding. Please try again later.",
        });
        setLoading(false);
        return;
      }

      // Check for both possible success status formats
      const isSuccess = verifierInitResponse?.status === "SUCCESS" || 
                       verifierInitResponse?.status === "success" ||
                       verifierInitResponse?.data?.status === "SUCCESS" ||
                       verifierInitResponse?.data?.status === "success";

 

      if (isSuccess) {
        
        // Update payload with SUCCESS status for both create and edit modes
        addNewPayload.status = "SUCCESS";
        
        // Step 2: Add credentials if verification is successful
        const response = await apiPost(
          API_ENDPOINT_EMAIL_ADD_NEW,
          addNewPayload
        );

        if (response.status) {
          messageApi.open({
            type: "success",
            content: response.message,
          });
          props.onSuccess && props.onSuccess();
        } else {
          messageApi.error({
            type: "error",
            content: response.message,
          });
        }
      } else {
        
        // Validation failed
        if (isEditMode) {
          // For edit mode, update with FAILED_LOGIN status
          addNewPayload.status = "FAILED_LOGIN";
          
          const response = await apiPost(
            API_ENDPOINT_EMAIL_ADD_NEW,
            addNewPayload
          );
          
          if (response.status) {
            messageApi.open({
              type: "warning",
              content: "Credential updated but validation failed. Please check your credentials.",
            });
            props.onSuccess && props.onSuccess();
          } else {
            messageApi.error({
              type: "error",
              content: response.message,
            });
          }
        } else {
          // For create mode, don't insert if validation fails
          messageApi.open({
            type: "error",
            content: "Validation not successful. Couldn't add the credential.",
          });
        }
      }
    } catch (error: any) {
      // Handle error case
      if (isEditMode) {
        // For edit mode, update with FAILED_LOGIN status even on error
        addNewPayload.status = "FAILED_LOGIN";
        
        try {
          const response = await apiPost(
            API_ENDPOINT_EMAIL_ADD_NEW,
            addNewPayload
          );
          
          if (response.status) {
            messageApi.open({
              type: "warning",
              content: "Credential updated but validation failed due to an error.",
            });
            props.onSuccess && props.onSuccess();
          }
        } catch (updateError) {
          messageApi.error({
            type: "error",
            content: "Failed to update credential.",
          });
        }
      } else {
        messageApi.error({
          type: "error",
          content: error?.message || "An unexpected error occurred",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSelectServiceProvider = (provider: string) => {
    setServiceProvider(provider);

    if (provider !== "Custom") {
      const config = ImapConfig[provider];
      if (config) {
        setImapHost(config.host);
        setImapPort(config.port.toString());
      }
    } else {
      setImapHost(""); // Clear for custom input
      setImapPort("");
    }
  };


  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setTooltipText('Code copied');
    setTimeout(() => setTooltipText('Copy code'), 2000); // Reset after 2 sec
  };

  return (
    <div className="CreateEmail">
      {!verificationUri ? (
        <div className="SetupForm" style={{ width: "100%" }}>

          <div className="FormContent">
            <Typography.Paragraph style={{ fontWeight: 500, fontSize: '20px' }} className="textServerConfig">
              Server Configuration
              {/* {imapHost} */}
            </Typography.Paragraph>

            <div >
              <div className="FormRow">
                <div className="FormGroup" style={{ width: "100%" }}>
                  <label style={{ display: "block", marginBottom: 9, fontWeight: 500 }} className="textProvider">
                    Provider <span style={{ color: "#F00" }}>*</span>
                  </label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select Provider"
                    onChange={handleSelectServiceProvider}
                    value={serviceProvider}
                    options={[
                      {
                        value: "Gmail",
                        label: (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <GoogleIcon style={{ fontSize: 16, marginRight: 6 }} />
                            <Typography>Gmail</Typography>
                          </div>
                        ),
                      },
                      {
                        value: "Outlook",
                        label: (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={outlook}
                              alt="Outlook Icon"
                              style={{ width: 50, height: 20, marginRight: -10, marginLeft: -15 }}
                            />
                            <Typography>Outlook</Typography>
                          </div>
                        ),
                      },
                      // {
                      //   value: "zoho",
                      //   label: (
                      //     <div style={{ display: "flex", alignItems: "center" }}>
                      //       <MicrosoftIcon
                      //         style={{ fontSize: 16, marginRight: 6 }}
                      //       />
                      //       <Typography>Zoho</Typography>
                      //     </div>
                      //   ),
                      // },
                      {
                        value: "zoho",
                        label: (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={zoho}
                              alt="Zoho Icon"
                              style={{ width: 25, height: 25, marginRight: 6 }}
                            />
                            <Typography>Zoho</Typography>
                          </div>
                        ),
                      },
                      {
                        value: "Custom",
                        label: (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <MicrosoftIcon
                              style={{ fontSize: 16, marginRight: 6 }}
                            />
                            <Typography>Custom</Typography>
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              </div>
              {serviceProvider === "Outlook" && (
                <div className="FormRow">
                  <div className="FormGroup" style={{ width: "100%" }}>
                    {/* <label
                    style={{ display: "block", marginBottom: 9, marginTop: 9, fontWeight: 500 }}
                  >
                    Authentication Method <span style={{ color: "#F00" }}>*</span>
                  </label> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: 'space-between',
                        marginBottom: 9,
                        marginTop: 9,
                      }}
                    >
                      <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9, marginTop: 9, }} >
                        Authentication Method<span style={{ color: "#F00", marginLeft: 2 }}>*</span>
                      </label>
                      <InfoCircleOutlined
                        id="auth-method-info"
                        onClick={(e) => {
                          e.stopPropagation();  // :white_check_mark: prevent card click
                          setCurrentStep(getStepIndexBySelector('#auth-method-info'));
                          setIsTourOpen(true);  // :white_check_mark: open the tour
                        }}
                        style={{ color: "#CCCCCC", cursor: "pointer" }}

                      />
                    </div>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Secondary Provider"
                      value={secondaryProvider}
                      options={[
                        {
                          value: "Delegated",
                          label: (
                            <Typography>Delegated</Typography>
                          ),
                        },
                        {
                          value: "App",
                          label: (
                            <Typography>App</Typography>
                          ),
                        },
                        {
                          value: "AppBased",
                          label: (
                            <Typography>App Based</Typography>
                          ),
                        },
                      ]}
                      onChange={(value) => setSecondaryProvider(value)}
                    />
                  </div>
                </div>
              )}
              {serviceProvider === "Custom" && (
                <>
                  <div className="FormRow" style={{ marginTop: '12px' }}>
                    <div className="FormGroup">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                          IMAP Host
                        </label>
                        <InfoCircleOutlined
                          id="IMAP"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#IMAP'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="imap_host"
                        rules={[
                          {
                            required: true,
                            message: "Please input your IMAP host",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input
                          placeholder="Enter IMAP Host"
                          onChange={(e: any) => setImapHost(e.target.value)}
                        />
                      </Form.Item>
                    </div>

                    <div className="FormGroup" >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                          IMAP Port
                        </label>
                        <InfoCircleOutlined
                          id="imapPort"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#imapPort'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="imap_port"
                        rules={[
                          {
                            required: true,
                            message: "Please input your IMAP port",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input
                          placeholder="Enter IMAP Port"
                          onChange={(e: any) => setImapPort(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </>
              )}


              <Form
                form={form}
                name="basic"
                onFinish={handleCreateEmail}
              >
                <Typography.Paragraph style={{ marginTop: 24, marginBottom: 20, fontWeight: 500 }} className="textLogin">
                  Login Credential
                </Typography.Paragraph>

                <div className="FormRow">
                  <div className="FormGroup">
                    <label style={{ display: "block", marginBottom: 9, fontWeight: 500 }} className="textEmailAdd">
                      Email Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <Form.Item
                      name="login_email"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please input your email",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Email"
                        prefix={<MailOutlined />}
                        onChange={(e: any) => setLoginEmail(e.target.value)}
                      />
                    </Form.Item>
                  </div>
                  
                  <div className="FormGroup">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: 'space-between',
                        marginBottom: 9,
                      }}
                    >
                      <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                        Password
                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                      </label>
                      <InfoCircleOutlined
                        id="Password"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentStep(getStepIndexBySelector('#Password'));
                          setIsTourOpen(true);
                        }}
                        style={{ color: "#CCCCCC", cursor: "pointer" }} />
                    </div>
                    <Form.Item
                      name="app_password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <Input.Password
                        placeholder="Enter Password"
                        prefix={<KeyOutlined />}
                        onChange={(e: any) => setLoginPassword(e.target.value)}
                      />
                    </Form.Item>
                  </div>
                </div>

                {/* App Password for Gmail/Zoho */}
                {(serviceProvider === "Gmail" || serviceProvider === "zoho") && (
                  <div className="FormRow" style={{ marginTop: '10px' }}>
                    <div className="FormGroup" style={{ width: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }}  >
                          App Password
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <InfoCircleOutlined
                          id="appPassword"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#appPassword'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="client_secret"
                        // rules={
                        //   serviceProvider === "Gmail"
                        //     ? [{ required: true, message: "Please input your app password" }]
                        //     : []
                        // }
                        rules={[{ required: true, message: "Please input your app password" }]}
                        style={{ width: "100%" }}
                      >
                        <Input.Password
                          placeholder="Enter app password"
                          onChange={(e: any) => setGmailPassword(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                )}

                {/* Client ID and Tenant ID for Outlook */}
                {serviceProvider === "Outlook" && (secondaryProvider === "Delegated" || secondaryProvider === "App") && (
                  <div className="FormRow" style={{ marginTop: '12px' }}>
                    <div className="FormGroup">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                          Client ID
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <InfoCircleOutlined
                          id="auth-method-delegated-clientID"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#auth-method-delegated-clientID'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="client_id"
                        rules={[
                          {
                            required: true,
                            message: "Please input your Client id",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input
                          placeholder="Enter Client ID"
                          onChange={(e: any) => setClientId(e.target.value)}
                        />
                      </Form.Item>
                    </div>

                    <div className="FormGroup" >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                          Tenant ID
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <InfoCircleOutlined
                          id="auth-method-delegated-tenantID"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#auth-method-delegated-tenantID'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="tenant_id"
                        rules={[
                          {
                            required: true,
                            message: "Please input your tenant id",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input
                          placeholder="Enter tenant Id"
                          onChange={(e: any) => setTenantId(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                )}

                {/* App Password for Outlook App method */}
                {serviceProvider === "Outlook" && secondaryProvider === "App" && (
                  <div className="FormRow" style={{ marginTop: '10px' }}>
                    <div className="FormGroup" style={{ width: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: 'space-between',
                          marginBottom: 9,
                        }}
                      >
                        <label className="textEmailPass" style={{ fontWeight: 500, marginRight: 9 }} >
                          App Password
                          <span style={{ color: "red", marginLeft: 4 }}>*</span>
                        </label>
                        <InfoCircleOutlined
                          id="appPassword"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentStep(getStepIndexBySelector('#appPassword'));
                            setIsTourOpen(true);
                          }}
                          style={{ color: "#CCCCCC", cursor: "pointer" }} />
                      </div>
                      <Form.Item
                        name="client_secret"
                        rules={[
                          {
                            required: true,
                            message: "Please input your client secret",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <Input.Password
                          placeholder="Enter client secret"
                          onChange={(e: any) => setLoginPassword(e.target.value)}
                        />
                      </Form.Item>
                    </div>
                  </div>
                )}

                {/* Buttons */}
                <div
                  style={{
                    display: "flex",
                    gap: '12px',
                    marginTop: 40,
                    width: '100%',
                  }}
                >
                  <Button
                    type="default"
                    style={{
                      padding: '20px 55px',
                      borderRadius: '8px',
                      fontSize: '13px',
                      color: '#0A8394',
                      borderColor: '#E6F3F4',
                      backgroundColor: '#E6F3F4',
                    }}
                    onClick={props.onClose}
                  >
                    Cancel
                  </Button>
                  <Button 
                    type="primary" 
                    htmlType="submit"
                    style={{
                      padding: '20px 35px',
                      borderRadius: '8px',
                      fontSize: '16px',
                    }}
                  >
                    {isEditMode ? 'Update Credential' : 'Add Credential'}
                  </Button>
                </div>
              </Form>
            </div>


          </div>
        </div>) : (
        verificationUri && (
          <div
            style={{

            }}
          >
            <p style={{
              marginBottom: 8,
              fontWeight: 700,
              color: '#555',
              fontSize: '18px',
              lineHeight: '28px',
              letterSpacing: '-0.4px',
              fontFamily: 'Noto Sans'
            }}>
              To complete your Outlook verification:
            </p>

            <p style={{
              marginBottom: 8,
              color: '#555',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              marginTop: '24px',
              fontFamily: "Noto Sans"
            }}>
              1. Copy the verification code below
            </p>

            <div
              style={{
                padding: " 10px 12px",
                borderRadius: '8px',
                border: '1px solid #D1D1D1',
                background: '#FFF',
                marginBottom: 16,
                marginTop: 12,
                display: 'flex',
                width: '40%',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              {code}

              <Tooltip title={tooltipText}>
                <span
                  onClick={handleCopy}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 15H5.4C4.07 15 3 13.93 3 12.6V5.4C3 4.07 4.07 3 5.4 3H12.6C13.93 3 15 4.07 15 5.4V6M11.4 9H18.6C19.2365 9 19.847 9.25286 20.2971 9.70294C20.7471 10.153 21 10.7635 21 11.4V18.6C21 19.2365 20.7471 19.847 20.2971 20.2971C19.847 20.7471 19.2365 21 18.6 21H11.4C10.7635 21 10.153 20.7471 9.70294 20.2971C9.25286 19.847 9 19.2365 9 18.6V11.4C9 11.0848 9.06208 10.7727 9.18269 10.4816C9.3033 10.1904 9.48008 9.9258 9.70294 9.70294C9.9258 9.48008 10.1904 9.3033 10.4816 9.18269C10.7727 9.06208 11.0848 9 11.4 9Z" stroke="#999999" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </Tooltip>
            </div>

            <hr style={{ height: '1px', width: '100%', backgroundColor: '#EAEAEA', border: 'none' }} />

            <p style={{
              marginBottom: 12,
              marginTop: 12,
              color: '#555',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              fontFamily: "Noto Sans"
            }}>
              2.  Click the link below to verify via Microsoft
            </p>

            <Button
              onClick={(e) => {
                window.open(verificationUri, '_blank', 'noopener,noreferrer');
                handleVerificationClick(e); // pass the click event
              }}
              style={{
                backgroundColor: '#3875F6',
                color: '#FFF',
                borderRadius: '7px',
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '20px',
                marginTop: '12px',
                height: '38px'
              }}
            >
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10.8333 4.99992L12.5 3.33325C13.3333 2.49992 15 2.49992 15.8333 3.33325L16.6666 4.16659C17.5 4.99992 17.5 6.66659 16.6666 7.49992L12.5 11.6666C11.6666 12.4999 9.99998 12.4999 9.16665 11.6666M9.16665 14.9999L7.49998 16.6666C6.66665 17.4999 4.99998 17.4999 4.16665 16.6666L3.33331 15.8333C2.49998 14.9999 2.49998 13.3333 3.33331 12.4999L7.49998 8.33325C8.33331 7.49992 9.99998 7.49992 10.8333 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              Verify via Microsoft
            </Button>

          </div>
        )
      )}
      {contextHolder}
      <Tour
        steps={getSteps()}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        startAt={currentStep}
        rounded={10}
        styles={{
          maskArea: (base: any) => ({
            ...base,
            borderRadius: 15,       // round the spotlight shape
          }),
          overlay: (base: any) => ({
            ...base,
            backgroundColor: "rgba(0,0,0,0.5)",  // lighter black overlay (50% opacity)
          }),
        }}
      />
    </div>
  );
}

export default CreateEmail;




